<template>
  <div class="container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="添加新餐厅" name="addCanteen">
        <el-row>
          <el-col :span="24">
            <el-form status-icon ref="formData" :model="formData" :rules="rules">
              <el-form-item prop="unit_name">
                <el-col :xs="6" :sm="5" :md="4" :lg="3" :xl="2">单位名称</el-col>
                <el-col :xs="18" :sm="19" :md="12" :lg="12" :xl="12">
                  <el-input
                    v-model="formData.unit_name"
                    placeholder="请填写单位名称"
                    @blur="existedEateryShow = true"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item prop="eatery_name">
                <el-col :xs="6" :sm="5" :md="4" :lg="3" :xl="2">食堂名称</el-col>
                <el-col :xs="18" :sm="19" :md="12" :lg="12" :xl="12">
                  <el-input
                    v-model="formData.eatery_name"
                    placeholder="食堂名称"
                    @change="resetEateryList"
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item v-for="(canteen, index) in formData.canteen_list" :key="index">
                <el-col :xs="6" :sm="5" :md="4" :lg="3" :xl="2">
                  {{
                  "餐厅" + (index + 1)
                  }}
                </el-col>
                <el-col :xs="6" :sm="9" :md="6" :lg="6" :xl="6">
                  <el-input
                    :ref="`select${index}`"
                    v-model="formData.canteen_list[index].canteen_name"
                    placeholder="餐厅名称"
                  ></el-input>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :xs="6" :sm="9" :md="6" :lg="6" :xl="5">
                  <el-select
                    v-model="formData.canteen_list[index].canteen_type"
                    placeholder="请选择识别类型"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.index"
                      :label="item.type"
                      :value="item.index"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :xs="2" :sm="2" :md="1" :lg="1" :xl="1">
                  <el-button
                    @click.prevent="removeCanteen(index)"
                    type="danger"
                    :plain="true"
                    icon="el-icon-delete"
                    v-if="formData.canteen_list.length > 1 && index !== 0"
                    circle
                  ></el-button>
                </el-col>
                <el-col :xs="1" :sm="0" :md="0" :lg="0" :xl="0">&nbsp;</el-col>
                <el-col :xs="2" :sm="2" :md="1" :lg="1" :xl="1">
                  <el-button
                    @click.prevent="addCanteen(index)"
                    type="primary"
                    :plain="true"
                    v-if="index + 1 === formData.canteen_list.length"
                    icon="el-icon-plus"
                    circle
                  ></el-button>
                </el-col>
              </el-form-item>
              <el-form-item prop="eatery_count">
                <el-col :xs="6" :sm="5" :md="4" :lg="3" :xl="2">登陆账号</el-col>
                <el-col :xs="18" :sm="19" :md="12" :lg="12" :xl="12">
                  <el-input v-model="formData.eatery_count" placeholder="登录账号"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item prop="password">
                <el-col :xs="6" :sm="5" :md="4" :lg="3" :xl="2">登陆密码</el-col>
                <el-col :xs="18" :sm="19" :md="12" :lg="12" :xl="12">
                  <el-input v-model="formData.password" placeholder="密码"></el-input>
                </el-col>
              </el-form-item>
            </el-form>
            <div class="btn-wrapper">
              <el-col :xs="18" :sm="19" :md="12" :lg="12" :xl="12">
                <el-button type="danger" @click="resetForm">重置</el-button>
                <el-button type="primary" @click="submitForm">提交</el-button>
              </el-col>
            </div>
          </el-col>
          <!--<el-col :span="8" :offset="-1" v-if="existedEateryShow">-->
          <!--<el-card class="box-card">-->
          <!--<div v-for="(eatery, index) in eateryList" :class='{duplicated: eatery.duplicated === true}' :key="index"-->
          <!--class="text item">-->
          <!--{{`${index + 1}. ${eatery.eatery_name}`}}-->
          <!--</div>-->
          <!--</el-card>-->
          <!--</el-col>-->
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="餐厅列表" name="canteenList">
        <el-input v-model="filter" placeholder="筛选"></el-input>
        <el-table :data="filterByName" height="800px">
          <el-table-column
                  header-align="center"
                  align="center"
                  prop="eatery_id"
                  label="食堂ID"
          ></el-table-column>
          <el-table-column
                  header-align="center"
                  align="center"
                  prop="canteen_id"
                  label="餐厅ID"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="canteen_name"
            label="餐厅"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_name"
            label="所属食堂"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_account"
            label="账号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="eatery_pwd"
            label="密码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="模式"
          >
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.network_type === '2'">内网</el-tag>
              <el-tag type="success" v-else>公网</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.network_type === '2'" type="text" @click="setNetType('1', scope.row)"
                         size="mini">设为公网模式
              </el-button>
              <el-button v-else type="text"
                         @click="setNetType('2', scope.row)"
                         size="mini">设为内网模式</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// eslint-disable-next-line
import {apiGetEateryList, apiRegister, apiSetLanCanteen} from '@/api';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import pinyinMatch from 'pinyin-match';

export default {
  name: "canteenAdmin",
  data() {
    let checkCanteen = (rule, value, callback) => {
      console.log(rule, value);
    };
    let checkEateryName = (rule, value, callback) => {
      this.eateryList.every(eatery => {
        if (eatery.eatery_name === value) {
          this.$set(eatery, "duplicated", true);
          return false;
        } else {
          return true;
        }
      })
        ? callback()
        : callback(new Error("与现有食堂名字重复"));
    };
    return {
      filter: "",
      activeName: "addCanteen",
      canteenListShow: false,
      existedEateryShow: false,
      formData: {
        canteen_list: [
          {
            canteen_name: "餐厅1"
          }
        ]
      },
      typeOptions: [
        {
          index: 1,
          type: "碗碟识别模式"
        },
        {
          index: 2,
          type: "内容识别模式"
        }
      ],
      rules: {
        unit_name: {
          required: true,
          message: "单位名字不能为空",
          trigger: "blur"
        },
        eatery_name: [
          {
            required: true,
            message: "食堂名字不能为空",
            trigger: "blur"
          },
          {
            validator: checkEateryName,
            trigger: "blur"
          }
        ],
        canteen_list1: {
          required: true,
          validator: checkCanteen,
          trigger: "blur"
        },
        eatery_count: {
          required: true,
          message: "账号不能为空",
          trigger: "blur"
        },
        password: {
          required: true,
          message: "密码不能为空",
          trigger: "blur"
        }
      }
    };
  },
  mounted() {
    this.setSubTitle("食堂账号管理");
    if (this.isCellPhone === true) {
      this.toggleSubMenu(false);
    }
    this.setAllCanteenList();
  },
  methods: {
    ...mapMutations(["setSubTitle", "toggleSubMenu"]),
    ...mapActions(["setAllCanteenList"]),
    async setNetType (netType, row) {
      const {canteen_id} = row;
      try {
        await apiSetLanCanteen(netType, canteen_id);
        this.$message.success('已设置为' + netType === '1' ? '公网模式' : '内网模式');
      } catch (e) {
        this.$message.error('设置失败' + e.message);
      }
    },
    showCanteenList() {
      this.canteenListShow = true;
      this.setAllCanteenList();
    },
    resetEateryList() {
      this.eateryList.forEach(eatery => {
        eatery.duplicated = false;
      });
    },
    removeCanteen(index) {
      if (index > 0) {
        this.formData.canteen_list.splice(index, 1);
      }
    },
    addCanteen() {
      this.formData.canteen_list.push({
        canteen_name: "",
        canteen_type: ""
      });
    },
    resetForm() {
      this.formData = {
        canteen_list: [
          {
            canteen_name: "餐厅1"
          }
        ]
      };
      this.$refs["formData"].resetFields();
    },
    submitForm() {
      // eslint-disable-next-line
      let that = this;
      this.$refs["formData"].validate(valid => {
        if (valid) {
          apiRegister({ ...this.formData, add_flag: 0 })
            .then(res => {
              if (res.state_code === 0) {
                that.$message({
                  type: "success",
                  message: "成功添加账户"
                });
                this.resetForm();
                this.getEateryList();
              } else {
                // eslint-disable-next-line
                return Promise.reject("添加失败, " + res.error_msg);
              }
            })
            .catch(e => {
              this.$message({
                type: "error",
                message: e
              });
            });
        } else {
          this.$message({
            type: "error",
            message: "请完善表单"
          });
        }
      });
    },
    getEateryList() {
      apiGetEateryList({ apiKey: this.userinfo.api_key })
        .then(res => {
          if (res.state_code === 0) {
            this.$store.commit("setEateryList", res.data.eatery_list);
          } else {
            return Promise.reject(new Error("查询食堂列表出错"));
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {
    ...mapGetters(["allCanteenList"]),
    ...mapState({
      eateryList(state) {
        return state.global.eateryList;
      }
    }),
    filterByName() {
      let list = this.allCanteenList;
      let search = this.filter;
      if (search !== "") {
        return list.filter(a => {
          let res = pinyinMatch.match(
            a.canteen_name + "," + a.eatery_name,
            search
          );
          return res.length > 0;
          // return canteen['canteen_name'].indexOf(search) !== -1 || canteen['eatery_name'].indexOf(search) !== -1;
        });
      } else {
        return list;
      }
    },
    isCellPhone() {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    dialogWidth() {
      return this.isCellPhone ? "80%" : "40%";
    },
    userinfo() {
      return this.$store.getters.userinfo();
    }
  },
  watch: {
    canteenListShow(val, oldval) {
      if (val === false) {
        this.filter = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .box-card {
    .duplicated {
      color: red;
    }
  }
}
</style>
